/**
 * View Toggle Component
 *
 * Reusable toggle for switching between card and table views.
 *
 * @module components/common/ViewToggle
 */

import React from 'react';
import { ButtonGroup, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './ViewToggle.css';

/**
 * ViewToggle Component
 *
 * @param {Object} props
 * @param {string} props.viewMode - Current view mode ('card' or 'table')
 * @param {Function} props.onToggle - Callback when view mode changes
 * @param {string} props.className - Additional CSS classes
 */
const ViewToggle = ({ viewMode, onToggle, className = '' }) => {
  // Se quita `size="sm"`: btn-sm da ~31px de alto y este control aparece en las
  // 17 listas que cumplen el estandar del repo, o sea que era el control mas
  // repetido del producto y no se podia tocar bien en un telefono. El ancho
  // compacto de escritorio se recupera por CSS (ViewToggle.css), sin bajar del
  // piso tactil de 44px.
  //
  // `title` no es un nombre accesible fiable (no lo anuncian todos los lectores
  // de pantalla y no existe en tactil), asi que ademas va `aria-label`. Y
  // `aria-pressed` porque son dos botones de estado, no dos acciones.
  return (
    <ButtonGroup className={`view-toggle ${className}`.trim()}>
      <Button
        variant={viewMode === 'card' ? 'primary' : 'outline-secondary'}
        onClick={() => onToggle('card')}
        title="Vista de tarjetas"
        aria-label="Ver como tarjetas"
        aria-pressed={viewMode === 'card'}
      >
        <i className="bi bi-grid-3x3-gap-fill" aria-hidden="true"></i>
      </Button>
      <Button
        variant={viewMode === 'table' ? 'primary' : 'outline-secondary'}
        onClick={() => onToggle('table')}
        title="Vista de tabla"
        aria-label="Ver como tabla"
        aria-pressed={viewMode === 'table'}
      >
        <i className="bi bi-list-ul" aria-hidden="true"></i>
      </Button>
    </ButtonGroup>
  );
};

ViewToggle.propTypes = {
  viewMode: PropTypes.oneOf(['card', 'table']).isRequired,
  onToggle: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default ViewToggle;
